import { render, staticRenderFns } from "./vehicle-detail.vue?vue&type=template&id=34fe87c3"
import script from "./vehicle-detail.vue?vue&type=script&lang=js"
export * from "./vehicle-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports